import urlResolver from 'admin/utils/URLResolver';
import useSWR from 'swr';
import { Task } from 'edrolo/domains/coursePortal/types/Task';

type PaginatedResponse<T> = {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
};

type UseTasksStudentParams = {
  page?: number;
  pageSize?: number;
  status?: string[];
  assignmentStage?: string[];
  taskType?: string;
  dueDatetimeGte?: string;
  dueDatetimeLte?: string;
  startDatetimeLte?: string;
  ordering?: string;
  courseId?: number | string;
};

export const useTasksStudent = (params: UseTasksStudentParams = {}) => {
  const page = params.page;
  const pageSize = params.pageSize;
  const status = params.status;
  const assignmentStage = params.assignmentStage;
  const taskType = params.taskType;
  const dueDatetimeGte = params.dueDatetimeGte;
  const dueDatetimeLte = params.dueDatetimeLte;
  const startDatetimeLte = params.startDatetimeLte;
  const ordering = params.ordering;
  const courseId = params.courseId;

  const buildUrl = () => {
    const baseUrl = urlResolver.reverse('api:student_tasks-list');
    const queryParams = new URLSearchParams();

    if (page !== undefined) {
      queryParams.append('page', String(page));
    }
    if (pageSize !== undefined) {
      queryParams.append('page_size', String(pageSize));
    }
    if (status && status.length > 0) {
      status.forEach((s) => queryParams.append('status', s));
    }
    if (assignmentStage && assignmentStage.length > 0) {
      assignmentStage.forEach((s) => queryParams.append('assignment_stage', s));
    }
    if (taskType) {
      queryParams.append('task_type', taskType);
    }
    if (dueDatetimeGte) {
      queryParams.append('due_datetime__gte', dueDatetimeGte);
    }
    if (dueDatetimeLte) {
      queryParams.append('due_datetime__lte', dueDatetimeLte);
    }
    if (startDatetimeLte) {
      queryParams.append('start_datetime__lte', startDatetimeLte);
    }
    if (ordering) {
      queryParams.append('ordering', ordering);
    }
    if (courseId) {
      queryParams.append('course_id', String(courseId));
    }

    const queryString = queryParams.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
  };

  const { data, mutate, error, isLoading } = useSWR<PaginatedResponse<Task>>(
    buildUrl()
  );

  if (error) {
    console.error(error);
  }

  const tasks = data?.results || [];
  const totalCount = data?.count || 0;

  return {
    data: tasks,
    mutate,
    isLoading,
    error,
    totalCount,
  };
};
